module.exports = __webpack_public_path__ + "img/1920.365fcb5d.png";